import { render, staticRenderFns } from "./BtHistogramMetricsModel.vue?vue&type=template&id=3a3ba924&scoped=true&"
import script from "./BtHistogramMetricsModel.vue?vue&type=script&lang=js&"
export * from "./BtHistogramMetricsModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3ba924",
  null
  
)

export default component.exports